import createSurveyForm from 'utils/createSurveyForm';

export const FORM = 'surveyEditForm';

const SurveyEditForm = createSurveyForm(FORM);

export default SurveyEditForm;
